export const TIMETABLE_DATA_ELEMENT = '[data-element="timetable"]';

// CLASSES
export const COMPONENT_CLASS = 'at-timetable';
export const SHADOW_CLASS = `${COMPONENT_CLASS}__shadow`;
export const SHADOW_EARLIER_CLASS = `${SHADOW_CLASS}-earlier`;
export const SHADOW_LATER_CLASS = `${SHADOW_CLASS}-later`;

// SELECTORS
export const COMPONENT_SELECTOR = `.${COMPONENT_CLASS}`;
export const TIME_COLUMN_SELECTOR = `${COMPONENT_SELECTOR}__col-time`;
export const NAVIGATION_SELECTOR = `${COMPONENT_SELECTOR}__navigation`;
export const NAVIGATION_PREV_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-prev`;
export const NAVIGATION_NEXT_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-next`;
export const HEADER_TITLE_SELECTOR = `${COMPONENT_SELECTOR}__header-title`;
export const CONTENT_SELECTOR = `${COMPONENT_SELECTOR}__content`;
export const COL_STOP_SELECTOR = `${COMPONENT_SELECTOR}__col-stop`;
export const CELL_SELECTOR = `${COMPONENT_SELECTOR}__cell`;
export const ROW_SELECTOR = `${COMPONENT_SELECTOR}__row`;

export const DIRECTION = {
  PREV: 0,
  NEXT: 1,
};

export const SWIPE_THRESHOLD = 50;

export const NO_STOP_TEXT = 'No Stop';